import { render } from "./BillingRunStatistic.vue?vue&type=template&id=0c31d7f7"
import script from "./BillingRunStatistic.vue?vue&type=script&lang=js"
export * from "./BillingRunStatistic.vue?vue&type=script&lang=js"

import exportComponent from "/builds/swisscom/messaging/web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__